import mockLinkLandingPagesData from "../data/mockData/linkLandingPagesData";
import {
  getActiveDemoLandingSeedRows,
  getDemoLandingRows,
} from "./demoLinkLandingSessionStore";

function mergeById(baseRows, extraRows) {
  const map = new Map();
  (baseRows || []).forEach(row => {
    if (row && row.id != null) {
      map.set(String(row.id), row);
    }
  });
  (extraRows || []).forEach(row => {
    if (row && row.id != null) {
      map.set(String(row.id), { ...(map.get(String(row.id)) || {}), ...row });
    }
  });
  return Array.from(map.values());
}

const SEED_LANDING_CREATED_BY_ID = new Map(
  mockLinkLandingPagesData
    .filter(row => row?.id != null && row.created)
    .map(row => [String(row.id), row.created]),
);

export function getLinkLandingRows() {
  const merged = mergeById(
    getActiveDemoLandingSeedRows(mockLinkLandingPagesData),
    getDemoLandingRows(),
  );
  return merged.map(row => {
    const seedCreated = SEED_LANDING_CREATED_BY_ID.get(String(row.id));
    return seedCreated ? { ...row, created: seedCreated } : row;
  });
}

function serializeImageField(value) {
  if (value == null || value === "") {
    return value;
  }
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "object" && value.default) {
    return value.default;
  }
  return String(value);
}

function serializeAssetField(value) {
  if (value == null || value === "") {
    return value;
  }
  if (typeof value === "string") {
    return serializeImageField(value);
  }
  if (typeof value === "object") {
    const next = {};
    ["thumb_small", "thumb_medium", "full_size"].forEach(key => {
      if (value[key] != null) {
        next[key] = serializeImageField(value[key]);
      }
    });
    if (Object.keys(next).length) {
      return next;
    }
    return serializeImageField(value.default || value);
  }
  return String(value);
}

/** JSON-safe rows for clipboard export (e.g. updating linkLandingPagesData.js). */
export function getLinkLandingMockExportPayload() {
  return getLinkLandingRows().map(row => ({
    ...row,
    logo: serializeAssetField(row.logo),
    background_image: row.background_image
      ? serializeAssetField(row.background_image)
      : row.background_image,
  }));
}
